module.exports = __webpack_public_path__ + "media/images/font/Gustavo-Italic-b4eadfc9c44ec353938f8cd30c6b6a5a.ttf";